export const DELIVERABLE_CONTENT_ACTIVITY_STATUS_NONE = '';
export const DELIVERABLE_CONTENT_ACTIVITY_STATUS_REVIEW = 'content_submission';
export const DELIVERABLE_CONTENT_ACTIVITY_STATUS_REJECTED = 'rejection';
export const DELIVERABLE_CONTENT_ACTIVITY_STATUS_APPROVED = 'approval';
export const DELIVERABLE_CONTENT_ACTIVITY_STATUS_COMPLETED = 'completed';
export const DELIVERABLE_CONTENT_ACTIVITY_STATUS_LABELS = {
    [DELIVERABLE_CONTENT_ACTIVITY_STATUS_NONE]: 'Unsubmitted',
    [DELIVERABLE_CONTENT_ACTIVITY_STATUS_REVIEW]: 'In Review',
    [DELIVERABLE_CONTENT_ACTIVITY_STATUS_REJECTED]: 'Changes Requested',
    [DELIVERABLE_CONTENT_ACTIVITY_STATUS_APPROVED]: 'Approved',
    [DELIVERABLE_CONTENT_ACTIVITY_STATUS_COMPLETED]: 'Completed'
};
export const DELIVERABLE_CONTENT_ACTIVITY_STATUS_COLORS = {
    [DELIVERABLE_CONTENT_ACTIVITY_STATUS_NONE]: 'basic',
    [DELIVERABLE_CONTENT_ACTIVITY_STATUS_REVIEW]: 'primary',
    [DELIVERABLE_CONTENT_ACTIVITY_STATUS_REJECTED]: 'warning',
    [DELIVERABLE_CONTENT_ACTIVITY_STATUS_APPROVED]: 'good',
    [DELIVERABLE_CONTENT_ACTIVITY_STATUS_COMPLETED]: 'good'
};
export const DELIVERABLE_CONTENT_ACTIVITY_ERROR_MESSAGES = {
    [DELIVERABLE_CONTENT_ACTIVITY_STATUS_NONE]: 'Brand approval is required before you post.',
    [DELIVERABLE_CONTENT_ACTIVITY_STATUS_REVIEW]: 'Your submission is in review. A notification will be sent to you once it is reviewed.',
    [DELIVERABLE_CONTENT_ACTIVITY_STATUS_REJECTED]: 'The brand has requested changes. Please complete these changes and resubmit your content for approval.',
    [DELIVERABLE_CONTENT_ACTIVITY_STATUS_APPROVED]: 'Your content has been approved! You may now share it on the agreed upon post date.',
    [DELIVERABLE_CONTENT_ACTIVITY_STATUS_COMPLETED]: 'This task is complete.'
};
